/**
 * AuditoriaObservacao
 * @author Simpli CLI generator
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import Responsavel from '@/model/resource/Responsavel'
import AuditoriaObservacaoSchema from '@/schema/AuditoriaObservacao.schema'
import {AuditoriaLogConforme} from '@/enums/AuditoriaLogConforme'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'
import Administrador from '@/model/resource/Administrador'

export default class AuditoriaObservacao extends Resource {
  readonly $name: string = 'AuditoriaObservacao'

  readonly $endpoint: string = '/user/carga/{idCarga}/auditoria-observacao'

  get $schema() {
    return AuditoriaObservacaoSchema(this)
  }

  get $id() {
    return this.idObservacaoPk
  }
  set $id(val: ID) {
    this.idObservacaoPk = val
  }

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  responsavelUsuario: ResponsavelUsuario | null = null

  administrador: Administrador | null = null

  idObservacaoPk: ID = 0

  texto: string = ''

  subtexto: string | null = null

  dataEnvio: string | null = null

  replicarCTE: boolean | null = null

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(idCargaFk: ID) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = idCargaFk
  }

  get borderClass() {
    return {
      'border-success': this.texto === AuditoriaLogConforme.CONFORME,
      'border-danger': this.texto.startsWith(AuditoriaLogConforme.NAO_CONFORME),
    }
  }

  async persistAuditoriaObservacao(model: AuditoriaObservacao, spinner = 'persistAuditoria') {
    const fetch = async () => {
      await model.validate()
      return await this.POST(`/user/carga/${model.idCargaFk}/auditoria-observacao`, model)
    }

    return await $.await.run(fetch, spinner)
  }

}
